import { useCallback, useState } from "react";

const AUTH_KEY = "selectra_admin_auth";

// NOTE ON SECURITY: this is a frontend-only gate, not real authentication.
// The password below ships inside the built JS bundle, so anyone who opens
// devtools and reads the source can find it — this only stops casual
// visitors from noticing/using the Manage Projects panel. Real protection
// (hiding this from anyone but a specific admin, rotating the password,
// etc.) requires a backend to verify credentials.
const ADMIN_PASSWORD = "selectra2026";

function readAuth() {
  try {
    return window.sessionStorage.getItem(AUTH_KEY) === "true";
  } catch {
    return false;
  }
}

/**
 * useAdminAuth
 * Simple session-scoped admin gate. `isAdmin` resets when the browser
 * tab/session ends (sessionStorage, not localStorage) so a login doesn't
 * linger forever on a shared computer.
 */
export default function useAdminAuth() {
  const [isAdmin, setIsAdmin] = useState(readAuth);

  const login = useCallback((password) => {
    console.log("INPass",password)
    console.log("APass",ADMIN_PASSWORD)
    if (password === ADMIN_PASSWORD) {
      setIsAdmin(true);
      try {
        window.sessionStorage.setItem(AUTH_KEY, "true");
      } catch {
        // sessionStorage unavailable — auth still works for this render.
      }
      return true;
    }
    return false;
  }, []);

  const logout = useCallback(() => {
    setIsAdmin(false);
    try {
      window.sessionStorage.removeItem(AUTH_KEY);
    } catch {
      // no-op
    }
  }, []);

  return { isAdmin, login, logout };
}
